export default __webpack_public_path__ + "20995140d33151ad26c43bd069481edf.jpg";